import React from 'react';
import { PublicPlan } from '@wix/ambassador-pricing-plans-v2-plan/types';
import { Plan } from '@wix/ambassador-pricing-plans-v3-plan/types';
import { VIEWER_HOOKS } from '@wix/pricing-plans-common/hooks';
import { isPlanV3 } from '@wix/pricing-plans-utils';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { getPlanValidityCycle } from '../../../../../utils';
import { getPlanValidityCycleV3 } from '../../../../../utils/plan-v3-utils';
import { st, classes } from './Validity.st.css';

export interface ValidityProps {
  plan: PublicPlan | Plan;
  highlighted: boolean;
  className?: string;
}

export const Validity: React.FC<ValidityProps> = ({ plan, highlighted, className }) => {
  const { t } = useTranslation();
  return (
    <span data-hook={VIEWER_HOOKS.PLAN_DURATION} className={st(classes.duration, { highlighted }, className)}>
      {isPlanV3(plan) ? getPlanValidityCycleV3(plan, t) : getPlanValidityCycle(plan, t)}
    </span>
  );
};
